export const SOURCE_UPLOAD_TYPE_LABELS: Record<string, string> = {
  upload_v3: 'Create / Modify',
  delete: 'Delete',
};

export const STATUS_CHIP_COLORS: Record<string, 'default' | 'primary' | 'success' | 'error' | 'warning' | 'info'> = {
  scheduled: 'info',
  processing: 'primary',
  completed: 'success',
  success: 'success',
  failed: 'error',
  cancelled: 'default',
  pending: 'warning',
};

export const DEFAULT_TIMEZONE = 'America/Los_Angeles';

export const POLL_INTERVAL_MS = 5000;

export const TERMINAL_STATUSES = new Set(['completed', 'success', 'failed', 'cancelled']);

export const STEP_LABELS: Record<string, string> = {
  catalog: 'Catalog Upload',
  algolia: 'Algolia Sync',
  shopify: 'Shopify Sync',
};

export const STEP_DESCRIPTIONS: Record<string, string> = {
  catalog: 'Step 1 \u00b7 Ingest & validate rows',
  algolia: 'Step 2 \u00b7 Index for search',
  shopify: 'Step 3 \u00b7 Publish to storefront',
};

export const getTimezoneList = (): string[] => {
  try {
    return Intl.supportedValuesOf('timeZone');
  } catch {
    // Fallback for older browsers
    return [
      'America/New_York',
      'America/Chicago',
      'America/Denver',
      'America/Los_Angeles',
      'America/Anchorage',
      'Pacific/Honolulu',
      'Europe/London',
      'Europe/Paris',
      'Asia/Tokyo',
      'Australia/Sydney',
      'UTC',
    ];
  }
};
